export default __webpack_public_path__ + "static/media/mobile.15a6bd83.png";